import React, { useLayoutEffect } from 'react';
import useWebContext from '../hooks/useWebContext';
import CustomAccordion from './CustomAccordion';
import CustomTabs from './CustomTabs';
import MetadataFilesSlider from './MetadataFilesSlider';

/**
 * MetadataContentTabs
 * @returns
 */
export const MetadataContentTabs = ({
  paramMetadataId,
  screenId,
  metadataContent,
  setIsLoading,
  // 2025.3.5 MyMine Version2.1対応 Add Start
  canShareContents,
  contentsShareParameter,
  isDefaultOpenFirstAccordion,
  // 2025.3.5 MyMine Version2.1対応 Add End
  //2025.7.7 Version3.0対応 Add Start
  isAhsMetadataContentTabs
  //2025.7.7 Version3.0対応 Add End
}) => {
  const { controlSettings } = useWebContext(screenId);
  const [selectedSlideMetadataList, setSelectedSlideMetadataList] = React.useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [defaultOpenAccordionMetadata, setDefaultOpenAccordionMetadata] = React.useState(Number(contentsShareParameter?.contentsMetadataId ? contentsShareParameter.contentsMetadataId : paramMetadataId));
  const [isInitialized, setIsInitialized] = React.useState(false);
  // 2025.3.5 MyMine Version2.1対応 Add End

  useLayoutEffect(() => {
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    // 2025.3.5 MyMine Version2.1対応 Modify Start
    let defaultOpenAccordionMetadataId;

    metadataContent.SecondCategoryHierarchyList.forEach((secondCategory, secondIndex) => {
      // パラメータのMetadataIdに一致する.SecondCategoryMetadataがある場合、デフォルト選択
      if (secondCategory.MetadataId === Number(paramMetadataId)) {
        setSelectedTabIndex(secondIndex);
        defaultOpenAccordionMetadataId = secondCategory.ThirdCategoryHierarchyList[0].MetadataId;
      }
      secondCategory.ThirdCategoryHierarchyList.forEach((thirdCategory) => {
        // パラメータのMetadataIdに一致するThirdCategoryMetadataがある場合、デフォルト選択
        if (thirdCategory.MetadataId === Number(contentsShareParameter?.contentsMetadataId ? contentsShareParameter.contentsMetadataId : paramMetadataId)) {
          setSelectedTabIndex(secondIndex);
          defaultOpenAccordionMetadataId = thirdCategory.MetadataId;
        }
      })
    })
    if (isDefaultOpenFirstAccordion) {
      if (metadataContent.SecondCategoryHierarchyList.length !== 0)
      setDefaultOpenAccordionMetadata(defaultOpenAccordionMetadataId ?? metadataContent.SecondCategoryHierarchyList[0].ThirdCategoryHierarchyList[0].MetadataId);
    }
    setIsInitialized(true)
    // 2025.3.5 MyMine Version2.1対応 Modify End
    // 2024.9.16 MyMine Version2.0対応 Modify End
  }, []);

  /**
   * お気に入りコールバック処理
   * @param {number} favoriteFileId お気に入りファイルID
   */
  const callbackFavorite = (favoriteFileId) => {
    // Stateのお気に入り情報を更新
    metadataContent.SecondCategoryHierarchyList.forEach(secondCategory => {
      secondCategory.ThirdCategoryHierarchyList.forEach(thirdCategory => {
        thirdCategory.BoxFileList.forEach(stateBoxFile => {
          if (stateBoxFile.FileId === favoriteFileId) {
            stateBoxFile.IsFavorite = !stateBoxFile.IsFavorite;
          }
        })
      })
    })
  }
  //2025.7.7 Version3.0対応 Add Start
  const currentThirdList = metadataContent.SecondCategoryHierarchyList[selectedTabIndex]?.ThirdCategoryHierarchyList || [];
  //2025.7.7 Version3.0対応 Add End
  //2025.7.7 Version3.0対応 Add Start
  const openedAccordionId = currentThirdList.some(item => item.MetadataId === defaultOpenAccordionMetadata)
    ? defaultOpenAccordionMetadata
    : currentThirdList[0]?.MetadataId ?? null;
  //2025.7.7 Version3.0対応 Add End

  // 2025.3.5 MyMine Version2.1対応 Add Start
  if (!isInitialized)
    return <></>
  // 2025.3.5 MyMine Version2.1対応 Add End
 
  return (
    <CustomTabs
      selectedTabIndex={selectedTabIndex}
      setSelectedTabIndex={setSelectedTabIndex}
      tabCaptionList={
        // 2024.9.16 MyMine Version2.0対応 Modify Start
        metadataContent.SecondCategoryHierarchyList.map((x, i) => { return { id: x.MetadataId, caption: x.MetadataName.toUpperCase() } })
        // 2024.9.16 MyMine Version2.0対応 Modify End
      }
      tabContents=
      {
        metadataContent
          .SecondCategoryHierarchyList
          .filter((_, i) => selectedTabIndex === i)
          .map((secondCategory,currentTabIndex) =>
            secondCategory.ThirdCategoryHierarchyList.map((thirdCategory,thirdIndex) => {
              // 2025.3.5 MyMine Version2.1対応 Add Start
              //BoxFile並び替え
              if (contentsShareParameter) {
                thirdCategory.BoxFileList = thirdCategory.BoxFileList.sort((a) => {
                  const isFileDecryptedA = a.FileId === contentsShareParameter.previewFileId;
                  const isMetadataDecryptedA = a.MetadataId === Number(contentsShareParameter.contentsMetadataId);
                  // 並び替えの例：復号されたファイルを最初に持ってくる
                  if (isFileDecryptedA && isMetadataDecryptedA) return -1;
                  return 0;
                });

              }
              
              // 2025.3.5 MyMine Version2.1対応 Add End
              return (
                // 2024.9.16 MyMine Version2.0対応 Modify Start
                <CustomAccordion
                  key={thirdCategory.MetadataId}
                  // 2025.3.5 MyMine Version2.1対応 Modify Start
                  //2025.7.7 Version3.0対応 Modify Start
                  defaultOpen={
                    isAhsMetadataContentTabs ?
                      thirdCategory.MetadataId === defaultOpenAccordionMetadata :
                    thirdCategory.MetadataId === openedAccordionId
                  }
                  //2025.7.7 Version3.0対応 Modify End
                  // 2025.3.5 MyMine Version2.1対応 Modify Start
                  menuText={thirdCategory.MetadataName}
                  contents={
                    <MetadataFilesSlider
                      controlSettings={controlSettings}
                      screenId={screenId}
                      selectedSlideMetadataList={selectedSlideMetadataList}
                      setSelectedSlideMetadataList={setSelectedSlideMetadataList}
                      callbackFavorite={callbackFavorite}
                      metadataId={thirdCategory.MetadataId}
                      fileList={thirdCategory.BoxFileList}
                      setIsLoading={setIsLoading}
                      //2025.3.5 MyMine Version2.1対応 Add Start
                      canShareContents={canShareContents}
                      //2025.2.17 MyMine Version2.1対応 Add End
                    />}
                />
                // 2024.9.16 MyMine Version2.0対応 Modify End
              )
            })
          )
      }
    />
  );
}
